export const ApplicationConstant = {
    ApplicationID : 26,
    clientId : 15,
    organizationId: 84,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD',
    KWAppID: 25
}